import styled from '@emotion/styled';
import { Box } from '@mui/material';
import { Image, Text } from 'components';
import DelogueLogoBig from 'img/delogue-logo-big.svg';

type WelcomeProps = {
  children: React.ReactNode;
  size?: 'small' | 'large';
};

export const Welcome = ({ children, size = 'small' }: WelcomeProps) => {
  return (
    <WelcomeCon size={size} sx={{ width: { xs: '100%', md: '50%' } }}>
      <Image
        src={DelogueLogoBig}
        alt="Delogue logo name"
        width="100%"
        height="100%"
        fit="contain"
      />
      <TextCon>
        <Text variant="bodyMd" fontFamily="Gazpacho" color="brandPrimary">
          {children}
        </Text>
      </TextCon>
    </WelcomeCon>
  );
};

const TextCon = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  min-width: 60%;
`;

const WelcomeCon = styled(Box)<{ size: 'small' | 'large' }>`
  min-height: ${p => (p.size === 'large' ? '420px' : '350px')};
  background-color: ${p => p.theme.palette.fg.brandPrimary};
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  padding: ${p => (p.size === 'large' ? '54px 37px 55px 37px' : '35px 56px 23px 46px')};
`;
